<template>
	<div class="checkbox" @click='triggerCheck'>
		<input :value='value' class="input" type="checkbox">
		<div class="border" :style='{borderRadius:radius+"px"}'></div>
		<slot></slot>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
			}
		},
		props:{
			value:{
				type:Boolean,
				default:false,
			},
			radius:{
				type:Number,
				default:0,
			},
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {

		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				
			]),
			async initData(){

			},
			triggerCheck(){
				this.$emit('input',!this.value)
				this.$emit('change',!this.value)
			}
		},
	}
</script>

<style lang='scss' scoped>
@import '@/style/mixin';
	.checkbox {
		display:flex;
		.input {
			display:none;
		}
		.border {
			border:1px solid #dcdee2;
			width:20px;
			height:20px;
		}
		.input[value='true'] + .border {
			border:1px solid $blue;
			background-color:$blue;
			position:relative;
			&:after {
				content: "";
			    display: table;
			    width: 4px;
			    height: 8px;
			    position: absolute;
			    top: 3px;
			    left: 6px;
			    border: 2px solid #fff;
			    border-top: 0;
			    border-left: 0;
			    transform: rotate(45deg) scale(1);
			    transition: all .2s ease-in-out;
			}
		}
	}
</style>